<template>
        <div class="case_box">
            <!-- <p><b>{{langtrans().ajxsxx[languageIndex]}}</b></p> -->
            <ul >
                <li v-for="(v,ind) in inf" :key="ind">
                    <span v-if="v.flag" class="btn_box" :class="{'blue':v.url}"  @click="tourl(v.url)">
                       <span>{{v.url?v.data:'无'}}</span> 
                    </span>
                    <span v-else>
                        {{v}}
                    </span>
                </li>
            </ul>
        </div>
</template>

<script>

import langtrans from "./js/parheader.vue.trans.js";
import qs from "qs";
import constants from '@/util/constants.js';
export default {
  props: ["caseid"],
  data() {
    return {
      inf:{},
      casenumber:"",
      usertype: JSON.parse(window.localStorage.getItem("usertype")).data,
      token:JSON.parse(window.localStorage.getItem('data')).data,
    }
  },

		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
  methods:{
			langtrans(){
				return langtrans
			},

    tourl(url){
      if(url!=""){
        window.open(url);
      }
    },
		getDetail(){
			let z = this;
			fetch(constants.domain+"rescue/case/detail_case", {
				method: "POST",
				body: `token=${this.token}&caseId=${this.$route.query.caseid || this.$route.query.id}`,
				mode: "cors",
				headers: { "Content-Type": "application/x-www-form-urlencoded" }
			})
				.then(function(res) {
					return res.json();
				})
				.then(function(data) {
					z.casenumber = data.obj.obj.caseNo;
					let o = data.obj.obj;
					let victimList = data.obj.victimList[0].obj;
					let reportUser = o.reportUser || "";
					let reportPhone = o.reporterContact || "";
					var exp=''
					if(o.caseSrcDesc){
						if(!constants.setTxt(o.caseSrcDesc,'zh')){
							exp=z.langtrans().lyssym[z.languageIndex] + o.caseSrcDesc
						}else{
							exp=z.langtrans().lyssym[z.languageIndex] + constants.setTxt(o.caseSrcDesc,'zh')
						}
					}else{
						exp=z.langtrans().lyssym[z.languageIndex]+ '无'
					}
					z.inf = {
					time: z.langtrans().basjj[z.languageIndex] + constants.time(o.reportTs),
					user: z.langtrans().bakh[z.languageIndex] + reportUser,
					sex: z.langtrans().xbbn[z.languageIndex]+ (victimList.gender == '1'?z.langtrans().nan[z.languageIndex] : z.langtrans().nv[z.languageIndex]),
					phone: z.langtrans().badh[z.languageIndex] + reportPhone,
					instime: z.langtrans().cxsjj[z.languageIndex] + constants.time(o.incidentTs),
					null: "-",
					card: z.langtrans().zjhhm[z.languageIndex] + (victimList.idNo || ""),
					number: z.langtrans().bdcshh[z.languageIndex]+ (victimList.insurancePolicyNo || ""),
					pardata: {
						flag: true,
						data: z.langtrans().bdcsxq[z.languageIndex],
						url:(victimList.insurancePaper||"")
					},
					belong: z.langtrans().sszbxg[z.languageIndex] + (data.obj.victimList[0].insuranceCompany || ""),
					source: z.langtrans().ajxsxx[z.languageIndex] + (o.caseSrc || ""),
					exp
				};
        console.log(z.inf);
			});
		}
  },

  mounted(){
		this.getDetail()
  },
	watch:{
		languageIndex(){
			this.getDetail()
		},
    '$route.query.caseid'(){
      this.getDetail();
      console.log('我执行了吗');
    }
	}

};
</script>
<style scoped>
.case_box {
  width: auto;
}
.case_box p {
  line-height: 40px;
}
.case_box p span {
  margin-left: 1.25vw;
}
.case_box ul {
  overflow: hidden;
  border-left: 1px solid #d9ddde;
  border-top: 1px solid #d9ddde;
  box-sizing: content-box;
}
.case_box ul li {
line-height: 40px;
    float: left;
    border-bottom: 1px solid #d9ddde;
    border-right: 1px solid #d9ddde;
    padding: 0 5px;
    width: calc(33.3% - 11px);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
}
.blue{color: #11b0fa;}
</style>



// WEBPACK FOOTER //
// src/components/par/parheader.vue